export default __webpack_public_path__ + "static/media/footer-home-vrcharacter.9ef03661.png";